export const config =  {
  fieldControl: false,
  rowSelection: false,
  columns: [
    {
      title: '身份ID',
      dataIndex: 'identityId',
      width: 200,
    },
    {
      title: '员工姓名',
      dataIndex: 'userName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '角色',
      dataIndex: 'roleName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '最后修改人',
      dataIndex: 'modifiedByName',
      width: 160,
    },
    {
      title: '最后修改时间',
      dataIndex: 'lastUpdatedTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '品牌',
      dataIndex: 'brandNames',
      width: 160,
      render: (v) => v?.join(", "),
      ellipsis: true,},
    {
      title: '渠道分类',
      dataIndex: 'channelCategoryNames',
      width: 200,
      render: (v) => v?.join(", "),
      ellipsis: true,
    },
    {
      title: '渠道',
      dataIndex: 'channelNames',
      width: 200,
      render: (v) => v?.join(", "),
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '员工姓名',
      name: 'userName',
    },
  ],
  footer: [
    {
      label: '添加',
      type: 'primary',
      events: ['onClick:onAdd']
    }
  ]
}
